import { render, staticRenderFns } from "./APagar-cuota.vue?vue&type=template&id=1b6cc1f4"
import script from "./APagar-cuota.vue?vue&type=script&lang=js"
export * from "./APagar-cuota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports